import { ToastContainer } from "react-toastify";

import React from "react";

export const AppModals = () => {
  return <ToastContainer />;
};
